import styled from "styled-components";

export const StyledWhiteBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 18px;
  gap: 8px;
  background: ${(props) => props.theme.figma.base.color_white_100};
  box-shadow: 0px 4px 20px 4px rgba(0, 0, 0, 0.08),
    0px 2px 10px 1px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  width: 100%;
  min-height: 278px;
  box-sizing: border-box;

  .mls-c-featured-match__prev {
    &:last-child{
      .mls-c-vertical-match:first-child{
        border-bottom: 0px;
      }
    }
  }
`;
